var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 39,
    viewBox: "0 0 74 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57245 38.9225C5.7315 38.9225 4.19737 38.8458 2.43312 38.8458C1.51265 38.8458 0.822266 38.0787 0.822266 37.1583V29.3343C0.822266 28.3371 1.58936 27.57 2.58655 27.6467C10.7174 27.9535 18.925 27.8001 24.6779 24.5785C29.2036 22.0472 30.4309 20.5898 33.7292 16.9079C34.9565 15.5271 36.4906 13.7629 38.5617 11.6151C48.15 1.56663 58.7355 -0.35102 72.3892 0.185924C73.3096 0.185924 74 0.952971 74 1.87344L73.9233 9.69748C73.9233 10.618 73.1562 11.385 72.159 11.385C59.4258 10.9248 52.599 13.0726 46.6926 19.2858C44.7749 21.2801 43.3942 22.8909 42.1669 24.2717C38.7151 28.1837 36.414 30.7917 30.2008 34.3202C23.5273 38.0788 15.6266 38.9225 7.57245 38.9225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftIcon);
export default __webpack_public_path__ + "static/media/lift-icon.ec7f55e5a3c4d61683793f94a24d1055.svg";
export { ForwardRef as ReactComponent };